import React from 'react';
import {
  CodeBracketIcon,
  EnvelopeIcon,
  GlobeAltIcon,
} from '@heroicons/react/24/outline';
import { ChannelType } from '../../types/atendimentoEnums';

interface ChannelTypeIconProps {
  channelType: ChannelType;
  className?: string;
}

const WhatsAppIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.85 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const TelegramIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0011.944 0zm5.618 8.16c-.185 1.898-.99 6.502-1.4 8.62-.173.898-.514 1.198-.844 1.228-.717.066-1.262-.474-1.957-.93-1.088-.716-1.704-1.16-2.76-1.86-1.222-.804-.43-1.246.267-1.968.183-.188 3.348-3.068 3.41-3.328.008-.032.015-.152-.057-.216-.072-.064-.178-.042-.255-.025-.109.024-1.84 1.17-5.19 3.436-.492.337-.937.502-1.336.494-.44-.01-1.286-.248-1.916-.452-.773-.25-1.386-.383-1.333-.807.028-.221.334-.446.918-.678 3.598-1.566 5.998-2.598 7.198-3.096 3.427-1.42 4.14-1.667 4.605-1.675.102-.002.33.024.478.146.124.104.158.243.176.343.02.11.045.328.03.508z" />
  </svg>
);

const InstagramIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.148-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0 5.838a4 4 0 100 8 4 4 0 000-8zm0 6.594a2.594 2.594 0 110-5.188 2.594 2.594 0 010 5.188zm5.081-6.982a1.03 1.03 0 100-2.06 1.03 1.03 0 000 2.06z" />
  </svg>
);

const MessengerIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2C6.477 2 2 6.145 2 11.257c0 2.914 1.446 5.516 3.727 7.244V22l3.405-1.87c.909.252 1.87.387 2.868.387 5.523 0 10-4.145 10-9.26C22 6.145 17.523 2 12 2zm1.007 12.472l-2.548-2.72-4.97 2.72 5.467-5.803 2.61 2.72 4.907-2.72-5.466 5.803z" />
  </svg>
);

export const ChannelTypeIcon: React.FC<ChannelTypeIconProps> = ({
  channelType,
  className = 'h-4 w-4',
}) => {
  switch (channelType)
  {
    case ChannelType.Whatsapp:
      return <WhatsAppIcon className={`${className} text-[#25D366]`} />;
    case ChannelType.Telegram:
      return <TelegramIcon className={`${className} text-[#26A5E4]`} />;
    case ChannelType.Instagram:
      return <InstagramIcon className={`${className} text-[#E1306C]`} />;
    case ChannelType.Messenger:
      return <MessengerIcon className={`${className} text-[#0084FF]`} />;
    case ChannelType.Email:
      return <EnvelopeIcon className={`${className} text-amber-500`} />;
    case ChannelType.Api:
      return <CodeBracketIcon className={`${className} text-gray-500`} />;
    case ChannelType.WebWidget:
    default:
      return <GlobeAltIcon className={`${className} text-indigo-500`} />;
  }
};
